class ContratoModalController extends AbstractController
  @$inject = [ '$injector', 'pathService', '$uibModalInstance', 'contratoService', 'entidadeService', 'atividadeService',
               'efRegimeTributarioService', 'alertaService', 'aplicacaoService', 'ferramentaDashboardService',
               'regimeTributarioIcmsService', 'perfilIcmsService', 'contrato' ]

  constructor: ($injector, pathService, @modalInstance, @contratoService, @entidadeService, @atividadeService,
    @regimeTributarioService, @alertaService, @aplicacaoService, @ferramentaDashboardService,
    @regimeTributarioIcmsService, @perfilIcmsService, @contrato) ->
    super($injector)

    @contrato.aplicacoes ?= []
    @contrato.perfisContrato ?= []
    @_cnpjFornecedor = {}
    @_perfilIcms = {}

    @loadingTracker = @promiseTracker()
    @listOfAtividade = []
    @listOfRegimeTributario = []
    @listOfRegimeTributarioIcms = []
    @listOfPerfil = []
    @listOfAlerta = []
    @listOfAplicacao = []
    @listOfFerramenta = []
    @ferramentasSelecionadas = []
    @_aplicacao = ''

    @editando = @contrato.id?
    if !@contrato.quantidadeDias
      @referenciaAgora = true
    else
      @referenciaAgora = @contrato.quantidadeDias == 0

    @modalContratoPerfilIcms = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/contrato/modal/regime-tributario-icms/modal.html', 'contratoPerfilIcmsModalController as ctrl', 'md')

    @submitTracker = @promiseTracker()
    @loadingPerfis = @promiseTracker()
    @loadDefaults()
    if @contrato.regimeTributarioIcms != undefined
      @contrato.regimeTributarioIcms = @contrato.regimeTributarioIcms.id
      @loadPerfis() if @contrato.regimeTributarioIcms

  loadDefaults: ->
    @loadingTracker.addPromise @atividadeService.getList((data) =>
      @listOfAtividade = data;

      @loadingTracker.addPromise @regimeTributarioService.getList((data) =>
        @listOfRegimeTributario = data

        @loadingTracker.addPromise @regimeTributarioIcmsService.getList({}, (data) =>

          @listOfRegimeTributarioIcms = data.data.items

          @loadingTracker.addPromise @alertaService.getAlertas((data)=>
            if data.success
              @listOfAlerta = data.data

              @contrato.alertas = {} if !@contrato.alertas? or @contrato.alertas.length?

              @listOfAlerta.each (alerta, tipo)=>
                @contrato.alertas[tipo] ?= 'nao'

            @loadingTracker.addPromise @aplicacaoService.getList((data) =>
              @listOfAplicacao = data

              @loadingTracker.addPromise @ferramentaDashboardService.getList({contrato: @contrato.id, select_type: 'complete'}, (ferramentasDashboard) =>
                for key, ferramenta of ferramentasDashboard
                  if ferramenta.dependencias?.length > 0
                    ferramenta.dependenciasTexto = "Depende de"

                    for ferramentaKey, index in ferramenta.dependencias
                      separador = null
                      separador ?= ' ' if index == 0
                      separador ?= ' e ' if index == (ferramenta.dependencias.length - 1)
                      separador ?= ', ' if ferramenta.dependencias.length > 0

                      ferramenta.dependenciasTexto += separador + '"' + ferramentasDashboard[ferramentaKey]?.title + '"'

                  ferramenta.valor = ferramenta.faturaServico?.valor
                  ferramenta.valor ?= 0
                  @moeda ?= ferramenta.faturaServico?.moeda?.sigla
                  @ferramentasSelecionadas.push(ferramenta) if ferramenta.ativa

                @listOfFerramenta = (ferramenta for key, ferramenta of ferramentasDashboard).sort (ferramentaA, ferramentaB) => parseInt(ferramentaA.indice) - parseInt(ferramentaB.indice)
              )
            )
          )
        )
      )
    )

  loadPerfis: ->
    @loadingPerfis.addPromise @perfilIcmsService.getList({regimeTributario: @contrato.regimeTributarioIcms}, (data)=>
      @listOfPerfil = data.data.items
    )

  selecionarTodasFerramentas: (event) ->
    if event.target.checked
      @ferramentasSelecionadas = angular.copy @listOfFerramenta
    else
      @ferramentasSelecionadas = []

  selecionarFerramenta: (event, ferramenta) ->
    if event == true or event?.target?.checked
      for dependenciaKey in ferramenta.dependencias
        if @ferramentasSelecionadas.select((_ferramenta) -> _ferramenta.id == dependenciaKey).length == 0
          dependencia = @listOfFerramenta.select((_ferramenta) -> _ferramenta.id == dependenciaKey)[0]
          if dependencia
            @ferramentasSelecionadas.push(dependencia)
            @selecionarFerramenta(true, dependencia)
    else
      for dependencia in angular.copy(@ferramentasSelecionadas).select((_ferramenta) -> _ferramenta.dependencias.indexOf(ferramenta.id) >= 0)
        @selecionarFerramenta(false, dependencia)

      @ferramentasSelecionadas = @ferramentasSelecionadas.select((_ferramenta) -> _ferramenta.dependencias.indexOf(ferramenta.id) == -1)

    return undefined

  addAplicacao: (aplicacao) ->
    try @contrato.aplicacoes.push aplicacao
    @_aplicacao = ''

  removerAplicacao: (index)->
    try @contrato.aplicacoes.splice(index, 1)

  getPerfisIcms: ->
    $.grep(@listOfPerfil, (perfil)=>
      item = @contrato.perfisContrato.select (contratoPerfil) =>
        if contratoPerfil.perfil == undefined
          return perfil.id == contratoPerfil.id
        else
          perfil.cnpjFornecedores = contratoPerfil.configuracoes.cnpjFornecedores
          perfil.numeroTermo = contratoPerfil.configuracoes.numeroTermo
          return perfil.id == contratoPerfil.perfil.id
      item.length == 0
    )


  addPerfilIcms: (perfil) ->
    try @contrato.perfisContrato.push {
      perfil: angular.copy perfil
      show: true
      configuracoes: {
        cnpjFornecedores: []
      }
    }

  removePerfilIcms: (index)->
    try @contrato.perfisContrato.splice(index, 1)

  infoPerfilIcms: (perfilContrato)->
    @modalContratoPerfilIcms(perfilIcms: -> perfilContrato.perfil)

  addCnpjFornecedor: (cnpj, perfil, index) ->
    perfil.configuracoes = {} if !perfil.configuracoes || angular.isArray(perfil.configuracoes);
    perfil.configuracoes.cnpjFornecedores = [] if !perfil.configuracoes.cnpjFornecedores

    if perfil.configuracoes.cnpjFornecedores.indexOf(cnpj) == -1
      try perfil.configuracoes.cnpjFornecedores.push angular.copy cnpj
    @_cnpjFornecedor[index] = ''

  removeCnpjFornecedor: (index, perfil)->
    try perfil.configuracoes.cnpjFornecedores.splice(index, 1)

  temItemDiario: () ->
    tem = false
    if @listOfAlerta?
      @listOfAlerta.each (alerta, tipo)=>
        tem = true if @contrato.alertas[tipo] == 'diario'
    return tem

  refreshEntidades: (search) ->
    (cbk.search (search) =>
      @listOfEntidade = undefined
      @loadingTracker.addPromise = @entidadeService.searchPagination(
        nome: search
        tipo: [ 'cliente' ]
        semContrato: true
      , (data) =>
        @listOfEntidade = data.items
      )
    )(search)

  salvar: (form, contrato) ->
    contrato = angular.copy contrato
    contrato.temEnvioDiario = @temItemDiario()
    contrato.ferramentasSelecionadas = (ferramenta.id for ferramenta in @ferramentasSelecionadas)
    contrato.aplicacoes = $.unique(aplicacao.id for aplicacao in contrato.aplicacoes)

    if(@referenciaAgora)
      contrato.quantidadeDias = 0

    callback = (result) =>
      if result.success
        @Alert.success("Empresa <strong>##{ result.data.contrato.id } - #{ result.data.contrato.razaoSocial } </strong> #{ if @editando then 'atualizado' else 'criado'} com sucesso.",
          "Sucesso!")
        cbk.abrirPopup(null, '/financeiro/boleto/fullPage/' + result.data.mensalidade.id) if result.data.mensalidade?.id
        @modalInstance.close(new Retorno(true))
      else
        @Alert.error("Ocorreu um erro ao salvar a empresa!", 'Erro!')

    if form.$valid and !contrato.empty()
      @submitTracker.addPromise(
        if contrato.id
          @contratoService.update(contrato, callback)
        else
          @contratoService.save(contrato, callback)
      )

angular.module("eficienciaFiscalModule").controller('contratoModalController', ContratoModalController)